import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center pt-24 pb-12 overflow-hidden" data-id="element-201">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.15] pointer-events-none" data-id="element-202" />
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-blue-600/20 blur-[120px] rounded-full pointer-events-none" data-id="element-203" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full flex flex-col items-center text-center" data-id="element-204">
        <div className="flex flex-col items-center" data-id="element-205">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-blue-500/30 bg-blue-500/10 mb-8" data-id="element-206">
            <span className="w-2 h-2 rounded-full bg-blue-500 animate-pulse" data-id="element-207" />
            <span className="text-xs font-medium text-blue-400 uppercase tracking-widest" data-id="element-208">
              Stop selling sites. Start selling digital assets.
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-white leading-[1.1] mb-6" data-id="element-209">
            Your Digital Presence Should Command Authority, Not Just Exist.
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="text-lg md:text-xl text-neutral-400 max-w-xl mb-10 leading-relaxed" data-id="element-210">
            PCS fuses high-performance web architecture with premium content
            strategy to build digital assets that generate revenue, not just
            traffic.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-col sm:flex-row items-start gap-4 w-full sm:w-auto" data-id="element-211">
            <a href="#contact" className="w-full sm:w-auto group flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-500 text-white px-8 py-4 rounded-sm font-medium transition-all" data-id="element-212">
              Analyze My Digital Presence
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-213" />
            </a>
            <a href="#contact" className="w-full sm:w-auto flex items-center justify-center bg-transparent border border-white/20 hover:border-white/40 hover:bg-white/5 text-white px-8 py-4 rounded-sm font-medium transition-all" data-id="element-214">
              Book a Strategy Call
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}